import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import emailjs from "emailjs-com";

const Contact: React.FC = () => {
  const navigate = useNavigate();
  const form = useRef<HTMLFormElement | null>(null);
  const [submitted, setSubmitted] = useState(false);
  
  const location = useLocation();

  useEffect(() => {
    setSubmitted(false);
  }, [location.pathname]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (form.current) {
      emailjs.sendForm(
        "service_znstrya", 
        "template_6r0hjsg", 
        form.current, 
        "2ZVC8ubcRhJLNnNZy"
      )
      .then((response) => {
        console.log("Email successfully sent!", response.status, response.text);
        setSubmitted(true);
      })
      .catch((err) => console.error("Failed to send email:", err));
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF0E6] px-6 py-16 flex flex-col justify-center items-center">
      {/* Title */}
      <h1 className="text-4xl md:text-5xl font-alice text-gray-800 text-center">Get in Touch</h1>
      <p className="text-md text-gray-600 text-center mt-2 max-w-xl">
        We're here to help. Reach out with your questions, feedback, or ideas — we’re listening.
      </p>

      {!submitted ? (
        <form ref={form} className="mt-8 space-y-6 max-w-2xl w-full" onSubmit={handleSubmit}>
          {/* Name Section */}
          <div>
            <label className="block text-gray-700 font-medium">Name <span className="text-gray-500">(required)</span></label>
            <div className="flex space-x-4 mt-2">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                className="w-1/2 p-3 border border-gray-300 rounded-md"
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                className="w-1/2 p-3 border border-gray-300 rounded-md"
                required
              />
            </div>
          </div>

          {/* Email */}
          <div>
            <label className="block text-gray-700 font-medium">Email <span className="text-gray-500">(required)</span></label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              className="w-full p-3 border border-gray-300 rounded-md mt-2"
              required
            />
          </div>

          {/* Message */}
          <div>
            <label className="block text-gray-700 font-medium">Message <span className="text-gray-500">(required)</span></label>
            <textarea
              name="message"
              rows={5}
              placeholder="Write your message here..."
              className="w-full p-3 border border-gray-300 rounded-md mt-2"
              required
            ></textarea>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#9CAF88] hover:bg-[#7f996e] text-white p-3 rounded-md transition-transform hover:scale-105"
          >
            SUBMIT
          </button>
        </form>
      ) : (
        <p className="text-lg text-[#9CAF88] mt-6 text-center">
          Thank you for contacting us! We will get back to you soon.
        </p>
      )}
    </div>
  );
};

export default Contact;